const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

export const busDumImages: string[] = Object.entries(photoModules)
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

import plan1np2d from "./plan-1np-2d.jpg";
import plan1np3d from "./plan-1np-3d.jpg";
import plan2np2d from "./plan-2np-2d.jpg";
import plan2np3d from "./plan-2np-3d.jpg";

export const busDumFloorPlans = [
  { image: plan1np2d, label: "1. NP – 2D" },
  { image: plan1np3d, label: "1. NP – 3D" },
  { image: plan2np2d, label: "2. NP – 2D" },
  { image: plan2np3d, label: "2. NP – 3D" },
];
